import { useQuery } from "react-query";
import { useIntl } from "react-intl";

import {
  ResourceLibraryItemType,
  ListResponseOfResourceLibraryItemType,
  ListRequestOfBaseFilter,
} from "services/KnowfullyAdminClient";
import useGlobalContext from "hooks/globalData";
import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";

type SelectResourceItemTypeProps = Omit<
  AutocompleteWithQueryProps<ResourceLibraryItemType>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectResourceLibraryItemType = (props: SelectResourceItemTypeProps) => {
  const { formatMessage: t } = useIntl();
  const { resourceLibraryService } = useGlobalContext();

  const fetchedResourceLibraryItemTypes = useQuery<ListResponseOfResourceLibraryItemType>(
    ["resourceLibraryItemTypes"],
    () =>
      resourceLibraryService.getResourceLibraryItemTypes(
        ListRequestOfBaseFilter.fromJS({
          sortField: "name",
        })
      )
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={fetchedResourceLibraryItemTypes}
      failMessage={t({ id: "selectResourceLibraryItemTypeFetchFailed" })}
    />
  );
};

export default SelectResourceLibraryItemType;
